// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import receptionFollowUpEntity from './entities/reception-follow-up.json';
import receptionFollowUpMenu from '../pages/reception-follow-up/menu.json';
import receptionFollowUpFullForm from '../pages/reception-follow-up/forms/full.json';
import receptionFollowUpContextForm from '../pages/reception-follow-up/forms/context.json';
import receptionFollowUpMiniForm from '../pages/reception-follow-up/forms/mini.json';
import receptionFollowUpLookupForm from '../pages/reception-follow-up/forms/lookup.json';
import receptionFollowUpTableView from '../pages/reception-follow-up/views/table.json';
import receptionFollowUpCardsView from '../pages/reception-follow-up/views/cards.json';
import receptionFollowUpCalendarView from '../pages/reception-follow-up/views/calendar.json';
import receptionFollowUpDashboardView from '../pages/reception-follow-up/views/dashboard.json';

/** Тип запису «Подальші дії після прийому» зі сторінками пакета: меню, форми та подання з pages/reception-follow-up/. */
export const receptionFollowUpDefinition: IRecordTypeDefinition = {
  ...receptionFollowUpEntity,
  views: assembleViewSet({
      table: receptionFollowUpTableView,
      cards: receptionFollowUpCardsView,
      calendar: receptionFollowUpCalendarView,
      dashboard: receptionFollowUpDashboardView,
  }),
  form: receptionFollowUpFullForm,
  forms: { full: receptionFollowUpFullForm, context: receptionFollowUpContextForm, mini: receptionFollowUpMiniForm, lookup: receptionFollowUpLookupForm },
  menu: receptionFollowUpMenu,
} as IRecordTypeDefinition;
